import { render, staticRenderFns } from "./Marshalls.vue?vue&type=template&id=7fb96f34&"
import script from "./Marshalls.vue?vue&type=script&lang=js&"
export * from "./Marshalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports